import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Wrapper, Title } from '../ModalComponents';
import { ButtonGroup, DeleteContent } from './StyledComponents';
import { Button } from '../FormStyles';

import Text from '../Text';

const DeleteComponent = ({ phrases, onConfirm, onCancel }) => {
  const { t } = useTranslation(['edit', 'shared']);

  return (
    <Wrapper>
      <Title>{t('edit:deleteComponent:title')}</Title>
      <DeleteContent>
        {phrases.map((phrase, index) => (
          <Text display="block" key={index}>
            {phrase}
          </Text>
        ))}
      </DeleteContent>
      <ButtonGroup>
        <Button onClick={() => onCancel()} variant="tertiary">
          {t('shared:no')}
        </Button>
        <Button onClick={() => onConfirm()} variant="containedRed" ml="8px">
          {t('shared:yes')}
        </Button>
      </ButtonGroup>
    </Wrapper>
  );
};

DeleteComponent.propTypes = {
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  phrases: PropTypes.array,
};

export default DeleteComponent;
